import { AutoManagedCampaignStatus, useUpdateAutoManagedCampaignsStatusMutation } from '@anytag/graphql';
import { SelectionBar, Button } from '@anytag/shared-atoms';
import { useQueryHelper, useSelectItemIds } from '@anytag/shared-hooks';

type ActionBarProps = Pick<
  ReturnType<typeof useSelectItemIds<number>>,
  'selectedItemIds' | 'hasAllItemsSelected' | 'toggleSelectAllItems' | 'setSelectedItemIds'
>;

export const ActionBar = ({
  selectedItemIds,
  hasAllItemsSelected,
  setSelectedItemIds,
  toggleSelectAllItems
}: ActionBarProps) => {
  const { t, enqueueSnackbar, invalidateRouteLoader } = useQueryHelper();
  const { loading: updatingStatus, callUpdateAutoManagedCampaignsStatus } = useUpdateAutoManagedCampaignsStatusMutation(
    { onCompleted: invalidateRouteLoader }
  );

  const numberSelectedIds = selectedItemIds.length;

  const handleChangeStatus = async (status: AutoManagedCampaignStatus) => {
    try {
      await callUpdateAutoManagedCampaignsStatus({
        variables: { input: { campaignIds: selectedItemIds, status } }
      });
      enqueueSnackbar(t('succeededUpdateStatus'), { variant: 'success' });
      setSelectedItemIds([]);
    } catch (error) {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    }
  };

  return numberSelectedIds > 0 ? (
    <SelectionBar
      disabled={updatingStatus}
      selectAllProps={{ onClick: toggleSelectAllItems }}
      checkboxProps={{
        disabled: updatingStatus,
        onClick: toggleSelectAllItems,
        indeterminate: !hasAllItemsSelected,
        label: t('Selected', { count: numberSelectedIds })
      }}
    >
      <Button
        title={t('Activate')}
        loading={updatingStatus}
        className="ml-4 px-4"
        tooltip={{ help: t('Show campaign to creators'), place: 'bottom' }}
        onClick={() => handleChangeStatus(AutoManagedCampaignStatus.ACTIVE)}
      />
      <Button
        title={t('Deactivate')}
        loading={updatingStatus}
        className="ml-4 px-4"
        tooltip={{ help: t('Hide campaign from creators'), place: 'bottom' }}
        onClick={() => handleChangeStatus(AutoManagedCampaignStatus.INACTIVE)}
      />
    </SelectionBar>
  ) : null;
};
